import moment from "moment";
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import ThrooRejectModal from "../../../components/modal/ThrooRejectModal";
import { PushSettingType, pushSettingState } from "../../../recoil/sound";
import { THROO_ORDER_STATE_COLOR, ThrooOrderType } from "../../../recoil/type";
import ButtonStatus from "./buttonStatus";

type OrderProps = {
  order: ThrooOrderType;
  isDetail: boolean;
};

const ThrooOrder = (oProps: OrderProps) => {
  const pushSetting = useRecoilValue<PushSettingType>(pushSettingState);
  const [isDetail, setIsDetail] = useState<boolean>(oProps.isDetail);
  const [isCopy, setIsCopy] = useState<boolean>(false);

  const [isBlink, setIsBlink] = useState<boolean>(false);
  // const [blinkCount, setBlinkCount] = useState<number>(
  //   pushSetting.autoPushOrder &&
  //     oProps.order.state_id === ORDER_READY_STATUS
  //     ? 3
  //     : 0
  // );

  console.log("oProps", JSON.stringify(oProps));

  const [visibleReject, setVisibleReject] = useState<boolean>(false);

  return (
    <>
      <Style>
        <div className="orderListWrap">
          <OrderInfoComponent {...oProps} />
          {/* 자세히 보기 */}
          {isDetail && <OrderDetailInfoComponent {...oProps} />}
          <div className="arrowDown" onClick={() => setIsDetail(!isDetail)}>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_${
                isDetail ? "up" : "down"
              }_black.svg`}
              alt="img"
            />
          </div>
        </div>
      </Style>
      <ThrooRejectModal
        isVisible={visibleReject}
        setVisible={setVisibleReject}
        order={oProps.order}
      />
    </>
  );
};

const OrderInfoComponent = (oProps: any) => {
  let oOrderData: ThrooOrderType = oProps.order;

  const maskPhoneNumber = (phoneNum: string) => {
    if (!phoneNum) {
      return phoneNum;
    }
    return phoneNum
      .trim()
      .replace(/[^0-9]/g, "")
      .replace(
        /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
        "$1-####-$3"
      )
      .replace("--", "-");
  };

  const getTotalQuantity = () => {
    let totalQuantity = 0;
    return totalQuantity;
  };

  const getMenuListString = () => {
    let menuString = "";
    let aPrdItems: any = Object.fromEntries(
      Object.entries(oOrderData).filter(([key]) => key.includes("items:"))
    );

    if (aPrdItems) {
      for (const sKey in aPrdItems) {
        let oPrdData = aPrdItems[sKey];
        menuString += `${oPrdData.prd_name} ${oPrdData.prd_quantity}개 /`;
      }
    }
    menuString = menuString.slice(0, -1);
    return menuString;
  };

  return (
    <div className="orderList">
      {/* 주문타입 및 시간 */}
      <div className="listLeft">
        <div>
          <h1>
            {moment(new Date(oOrderData.order_created_at)).format("HH:mm")}
          </h1>
          <p>
            {maskPhoneNumber(oOrderData.user_phone_number)}
            {/* {props.order.child.delivery_type} */}
          </p>
        </div>
        <div>
          {oOrderData.pickup_type === 1 && (
            <h2 className={`orderType delivery`}>DT</h2>
          )}
          {oOrderData.pickup_type === 2 && (
            <h2 className={`orderType delivery`}>포장</h2>
          )}
          <p>{oOrderData.license_number}</p>
        </div>
      </div>

      {/* 주문정보 */}
      <div className="listCenter">
        <div className="detailListWrap">
          <div className="flexItem title">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_throo_logo.svg`}
              alt="img"
            />
          </div>
          <h2 className="flexItem">{oOrderData.order_total_quantity}개</h2>
          <h2 className="flexItem right">
            {oOrderData.order_total_amount_org_show.toLocaleString()}원
          </h2>
        </div>
        <h3>{getMenuListString()}</h3>
        <h3 className={`requestText ${true ? "detail" : ""}`}>
          {oOrderData.inquiry}
        </h3>
      </div>

      {/* status변경 버튼 */}
      <ButtonStatus props={oProps} isBlink={false} setBlinkCount={10} />
    </div>
  );
};

const OrderDetailInfoComponent = (oProps: any) => {
  const [visibleReject, setVisibleReject] = useState<boolean>(false);

  let oOrderData: ThrooOrderType = oProps.order;

  const getTotalQuantity = () => {
    let totalQuantity = 0;
    return totalQuantity;
  };

  const getMenuListString = () => {
    let menuString = "";
    let aPrdItems: any = Object.fromEntries(
      Object.entries(oOrderData).filter(([key]) => key.includes("items:"))
    );

    if (aPrdItems) {
      for (const sKey in aPrdItems) {
        let oPrdData = aPrdItems[sKey];
        menuString += `${oPrdData.prd_name} ${oPrdData.prd_quantity}개 /`;
      }
    }
    menuString = menuString.slice(0, -1);
    return menuString;
  };

  const printKitchenReceiptOnly = () => {
    //PrinterController.preparePrintData(oOrderData, false, true);
  };

  const printCustomerReceiptOnly = () => {
    console.log("printCustomerReceiptOnly", oOrderData);
    //PrinterController.preparePrintData(oOrderData, true, false);
  };

  return (
    <div className="orderList detail">
      {/* 주문정보 */}
      <div className="detailWrap">
        <div className="detailItem">
          <div className="listLeft">
            <h3>{oOrderData.store_name}</h3>
          </div>
          <div className="listCenter">
            {/*props.order.child.detail.map(
              (item: OrderProductType, index: number) => {
                return (
                  <div className="orderDetailListWrap" key={index}>
                    <div className="detailListWrap">
                      <h3 className="flexItem title">{item.product_name}</h3>
                      <h3 className="flexItem">{item.product_quantity}개</h3>
                      <h3 className="flexItem right">
                        {item.product_total_amount.toLocaleString()}원
                      </h3>
                    </div>
                    {item.set_prd_type_list.map(
                      (set: SetPrdType, setIndex: number) => {
                        return (
                          <div className="optionListWrap" key={setIndex}>
                            <img
                              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_linebreak_black.svg`}
                              alt="img"
                            />
                            <div>
                              {set.set_product.map(
                                (setPrd: SetProduct, setPrdIndex: number) => {
                                  const getOptionName = () => {
                                    const optionNames = setPrd.options.map(
                                      (option: Option) => option.option_name
                                    );
                                    return optionNames.join(", ");
                                  };
                                  return (
                                    <div key={setPrdIndex} className="row">
                                      <h4>{setPrd.product_name}</h4>
                                      <div className="row option">
                                        <h5>{getOptionName()}</h5>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                    {item.options.map(
                      (option: Option, optionIndex: number) => {
                        return (
                          <div className="optionListWrap" key={optionIndex}>
                            <img
                              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_linebreak_black.svg`}
                              alt="img"
                            />
                            <h4>{option.option_name}</h4>
                          </div>
                        );
                      }
                    )}
                  </div>
                );
              }
            )*/}
            {/*props.order.child.delivery_tip > 0 && (
              <div className="detailListWrap tip">
                <h3 className="flexItem title">배달팁</h3>
                <h3 className="flexItem right">
                  {props.order.child.delivery_tip.toLocaleString()}원
                </h3>
              </div>
            )*/}
            {parseInt(oOrderData.order_discount_amount) > 0 && (
              <div className="detailListWrap tip">
                <h3 className="flexItem title">할인금액</h3>
                <h3 className="flexItem right">
                  -{oOrderData.order_discount_amount_show.toLocaleString()}원
                </h3>
              </div>
            )}
          </div>
        </div>
        {/* 배달정보 */}
        {/*
        <div className="detailItem">
          <div className="listLeft">
            <h3>{props.order.child.hotel_name}</h3>
          </div>
          <div className="listCenter">
            <div className="detailListWrap">
              <div className="flexItem address">
                <div className="row">
                  <h3 className="address">
                    {props.order.child.delivery_address}
                  </h3>
                  <div className={`copyButton ${isCopy && "disabled"}`} onClick={copyToClipBoardText}>
                    <img src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_copy${isCopy ? "_white" : ""}.svg`} alt="ic" />복사
                  </div>
                  <div className={`copyButton`} onClick={copyToDeliveryAppText}>
                    <img src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_copy${isCopy ? "_white" : ""}.svg`} alt="ic" />바로고로 전송
                  </div>
                </div>
                <h3 className="flexItem title">
                  {formatPhoneNumber(props.order.child.hotel_phone_number)}
                </h3>
              </div>
            </div>
          </div>
        </div>
        */}
        {/* 배달기사정보 */}
        {/* {props.order.child.delivery_type === 1 && (
        <div className="detailItem">
          <div className="listLeft">
            <h3>배달기사 이름</h3>
          </div>
          <div className="listCenter">
            <div className="detailListWrap">
              <h3 className="flexItem title">010-1234-5678</h3>
              <h3 className="flexItem">4,000원</h3>
              <h3 className="flexItem right">1.2km</h3>
            </div>
          </div>
        </div>
      )} */}
      </div>
      <div className="listRight">
        {oOrderData.state_color !==
          THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED &&
          oOrderData.state_color !==
            THROO_ORDER_STATE_COLOR.STORE_CANCELLED && (
            <button className="cancel" onClick={() => setVisibleReject(true)}>
              <h4>거절/취소</h4>
            </button>
          )}
        <button onClick={() => printKitchenReceiptOnly()}>
          <h4>주문서 재출력</h4>
        </button>
        <button onClick={() => printCustomerReceiptOnly()}>
          <h4>영수증 재출력</h4>
        </button>
      </div>
    </div>
  );
};

export default ThrooOrder;

const Style = styled.div`
  /* 줄임말 공통 */
  h4.info {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* text공통 */
  h1 {
    font-size: 32px;
    color: #333333;
    line-height: 36px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  h2 {
    font-size: 24px;
    line-height: 28px;
    color: #333333;
    font-weight: 600;
    white-space: nowrap;
  }
  h2.orderType {
    padding-top: 26px;
    padding-bottom: 4px;
  }
  h4 {
    color: #333333;
    font-weight: 400;
  }
  p {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    color: #999999;
  }

  .orderListWrap {
    padding: 36px 0 10px 0;
    margin: 0 3vw;
    border-bottom: 1px solid #d9d9d9;
  }
  .orderList {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }

  .listLeft {
    min-width: 120px;
    width: 120px;
    text-align: center;
    display: flex;
    flex-direction: column;
  }

  .listCenter {
    max-width: 100%;
    width: 100%;
    padding: 0 10px 10px 40px;
    overflow: hidden;

    .flexItem.title {
      width: 50%;
    }
    .flexItem {
      width: 25%;
    }
    .flexItem.right {
      text-align: right;
    }

    .requestText {
      width: 100%;
      color: #999999;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .requestText.detail {
      white-space: normal;
      text-overflow: clip;
      overflow: visible;
    }

    .detailListWrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .row {
        display: flex;
        align-items: center;
        gap: 80px;
      }
    }

    h3 {
      font-weight: 400;
      color: #999999;
      padding: 10px 0;
    }
  }

  /* 자세히 보기 클릭시 세부 정보 */
  .orderList.detail {
    width: 100%;
    padding-top: 10px;
    align-items: flex-start;
    position: relative;

    h3 {
      color: #333333;
      font-weight: 600;
      padding: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .flexItem.address {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 4;
      .row {
        gap: 8px;
        align-items: flex-start;
      }
    }

    .listLeft {
      padding-left: 14px;
      text-align: left;
    }
    .detailWrap {
      width: 100%;
      .detailItem {
        width: 100%;
        display: flex;
        margin-bottom: 30px;
      }
    }
    .listCenter {
      h3 {
        font-weight: 500;
      }
      h3.address {
        white-space: normal;
        font-weight: 400;
        line-height: 24px;
      }
      .detailListWrap {
        align-items: flex-start;
        margin-bottom: 0;
      }
      .detailListWrap.tip {
        max-width: 100%;
        margin-bottom: 6px;
      }
    }
    .optionListWrap {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      padding: 4px 0;
      .row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 2px;
        flex-wrap: wrap;
        h4 {
          white-space: nowrap;
        }
        .row.option {
          border-left: 1px solid #333333;
          gap: 6px;
          padding: 0 0 0 6px;
          h5 {
            white-space: normal;
            word-break: break-all;
            font-size: 13px;
            line-height: 16px;
            font-weight: 400;
            color: #444444;
          }
        }
      }
    }

    /* 버튼 */
    .listRight {
      margin-left: 140px;
      min-width: 140px;
      width: 140px;
      display: flex;
      gap: 10px !important;
      flex-direction: column;
      align-items: flex-end;
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        padding: 30px 0;
        background: #ffffff;
        border: 1px solid #999999;
        color: #000000;
        border-radius: 5px;
        h4 {
          font-weight: 600;
        }
      }
      button.cancel {
        border-color: #ff616b;
        h4 {
          color: #ff616b;
        }
      }
    }
  }
  .orderDetailListWrap {
    max-width: 100%;
    margin-bottom: 16px;
  }

  .arrowDown {
    text-align: center;
    cursor: pointer;
    img {
      margin-left: -100px;
    }
  }

  .copyButton {
    width: min-content;
    display: flex;
    align-items: center;
    color: #000000;
    border: 1px solid #999999;
    border-radius: 3px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    padding: 2px 6px;
    white-space: nowrap;
    gap: 2px;
    cursor: pointer;
  }
  .copyButton.disabled {
    color: #ffffff;
    background: #b2b2b2;
    border: 1px solid #b2b2b2;
  }
`;
